// components/CarouselNotas.tsx
import 'keen-slider/keen-slider.min.css'
import './CarouselNotas.scss'
import { useKeenSlider } from 'keen-slider/react'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { useTranslation } from 'react-i18next'
import { HOME_NOTES } from '../../../shared/constants/home-notes'
import { useState } from 'react'
import i18n from '../../../i18n/i18n'

const CarouselNotas = () => {
  const { t } = useTranslation()

  const [currentSlide, setCurrentSlide] = useState(0)
  const [loaded, setLoaded] = useState(false)

  const [sliderRef, slider] = useKeenSlider<HTMLDivElement>({
    loop: false,
    slides: {
      perView: 1,
      spacing: 15,
    },
    breakpoints: {
      '(min-width: 768px)': {
        slides: { perView: 2, spacing: 15 },
      },
      '(min-width: 1024px)': {
        slides: { perView: 3, spacing: 20 },
      },
    },

    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel)
    },
    created() {
      setLoaded(true)
    },
  })

  const getLink = (note: any): string => {
    const language = i18n.language

    if (language.includes('es')) {
      return note['link_es']
    } else if (language.includes('en')) {
      return note['link_en']
    } else {
      return note['link_pt']
    }
  }

  return (
    <div
      className="carousel-notas"
      style={{
        width: 'calc(100vw - 30px)',
        maxWidth: '100%',
      }}
    >
      <div ref={sliderRef} className="keen-slider">
        {HOME_NOTES.map((note, index) => (
          <div className="keen-slider__slide" key={index}>
            <a
              href={getLink(note)}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-white rounded-lg shadow-md overflow-hidden"
            >
              <div
                className="notas_image-container"
                style={{
                  backgroundImage: `url(${note.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              ></div>
              <h3>{t(note.title)}</h3>
              <p className="notas_author">
                <strong>{note.author}</strong> / {note.date}
              </p>
              <p className="notas_description">{t(note.description)}</p>
            </a>
          </div>
        ))}
      </div>

      {loaded && (
        <button
          onClick={() => slider.current?.prev()}
          className="buttons button-prev"
          // className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white p-2 rounded-full shadow hover:bg-gray-100"
          disabled={currentSlide === 0}
        >
          <ChevronLeftIcon />
        </button>
      )}

      {loaded && (
        <button
          onClick={() => slider.current?.next()}
          className="buttons button-next"
          // className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white p-2 rounded-full shadow hover:bg-gray-100"
          disabled={
            !slider.current ||
            slider.current.track.details.rel ===
              slider.current.track.details.slides.length -
                (typeof slider.current.options.slides === 'object' &&
                slider.current.options.slides !== null
                  ? typeof (slider.current.options.slides as any).perView ===
                    'number'
                    ? (slider.current.options.slides as any).perView
                    : 1
                  : typeof slider.current.options.slides === 'number'
                  ? slider.current.options.slides
                  : 1)
          }
        >
          <ChevronRightIcon />
        </button>
      )}
    </div>
  )
}

export default CarouselNotas
